export const NIDLP_SURVEY_ASSETS = {
  earth: '/nidlp-survey/earth.svg',
  welcome: '/nidlp-survey/welcome.svg',
  button: '/nidlp-survey/button.svg',
  clipboard: '/nidlp-survey/clipboard.svg',
  checkmark: '/nidlp-survey/checkmark.svg',
  qrEn: '/nidlp-survey/qr-en.svg',
  qrCn: '/nidlp-survey/qr-cn.svg',
} as const
